import './App.css';
import { BrowserRouter as HomeLayoutRoute, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Experience from './pages/Experience'
import Contact from './pages/Contact';


function App() {
  return (
    <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/#projects" element={<Projects />} />
        <Route path="/experiences" element={<Experience />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
    </Routes>
  );
}

export default App;
